import { useTranslation } from "react-i18next";

export function NotFoundPage() {
  const { t } = useTranslation("common");
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50 p-4 text-center">
      <p className="text-5xl font-bold text-slate-300">404</p>
      <p className="text-slate-600">{t("notFound.message")}</p>
      <a className="text-brand-700 hover:underline" href="/dashboard">
        {t("notFound.goDashboard")}
      </a>
    </div>
  );
}
